import { Outlet } from "react-router-dom"
import { AdminSettingsSidebar } from "./AdminSettingsSidebar"
import DeletePopup from "../../components/DeletePopup"
import { useState } from "react";

export const AdminSettingsLayout = () => {
    const [fullScreen, setFullScreen] = useState<boolean>(true);

    const handleScreen = () => {
        setFullScreen(!fullScreen);
    }

    return (
        <div className="flex bg-blue-50">
            <AdminSettingsSidebar handleScreen={handleScreen} />
            <div className={`${fullScreen ? 'w-[calc(100%-224px)]' : 'w-[calc(100%-50px)]'} h-max overflow-auto`}>
                <Outlet />
                <DeletePopup />
            </div>
        </div>
    )
}